import {useEffect, useState} from "react";
import {isAfter} from "date-fns";

const getReturnValues = countDown => {
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
    return [minutes, seconds];
};

const useCountdown = targetDate => {
    const isGivenTimeAfterCurrentTime = isAfter(targetDate, new Date());
    const countDownDate = new Date(targetDate).getTime();
    const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

    useEffect(() => {
        let interval;

        if (isGivenTimeAfterCurrentTime) {
            interval = setInterval(() => {
                const time = countDownDate - new Date().getTime();
                setCountDown(time);

                if (time === 0) {
                    clearInterval(interval);
                }
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [countDownDate, isGivenTimeAfterCurrentTime]);

    return getReturnValues(countDown);
};

const formatApiOrder = order => {
    console.log(order, "order");
    let normalizedStatus = order.status || "N/A";
    let normalizedPaymentStatus = order.payment?.status || order.paymentStatus || "N/A";
    if (normalizedStatus === "paid" && normalizedPaymentStatus === "N/A") {
        normalizedPaymentStatus = "paid";
        normalizedStatus = order.originalStatus || "new_order"; // fallback if backend didn't send
    }
    const bookingCode =
        order.integrations?.meta?.bookingCode || order.bookingCode || order.externalSyncMeta?.booking_code || "N/A";

    const deliveryAddress =
        order.fulfillment?.address?.street_address ||
        (order.fulfillment?.address?.city &&
        order.fulfillment?.address?.state &&
        order.fulfillment?.address?.postal_code
            ? `${order.fulfillment.address.street_address || ""} ${order.fulfillment.address.city || ""}, ${order.fulfillment.address.state || ""} ${order.fulfillment.address.postal_code || ""}`.trim()
            : order.store?.address?.street_address || "N/A");

    const customerFirstName = order?.customer?.profile?.first_name || order?.guestInfo?.name?.split(" ")[0] || "";
    const customerLastName =
        order?.customer?.profile?.last_name || order?.guestInfo?.name?.split(" ").slice(1).join(" ") || "";
    const customerName =
        customerFirstName || customerLastName ? `${customerFirstName} ${customerLastName}`.trim() : "N/A";

    const customerPhone =
        order.customer?.profile?.phone || order?.guestInfo?.phone || order?.integrations?.meta?.customer_phone || "N/A";

    const totalPrice = order.pricing?.total
        ? (order.pricing.total / 100).toFixed(2)
        : order.totalAmountInCents
          ? (order.totalAmountInCents / 100).toFixed(2)
          : "0.00";

    return {
        id: order.trackingId || order._id,
        bookingCode: bookingCode,
        pickupCode:
            order.integrations?.meta?.response?.pickup_code ||
            order.fulfillment?.externalDriver?.pickupCode ||
            order.deliveryInfo?.pickupCode ||
            order.pickupCode ||
            "N/A",
        name: customerName,
        phone: customerPhone,
        address: deliveryAddress,
        items: Array.isArray(order.items)
            ? order.items.map(i => ({
                  title: i?.menuItem?.name || i?.name || "N/A",
                  quantity: i?.quantity || 0,
                  addOn: i?.notes || "",
              }))
            : [],
        orderType: order.orderType || "N/A",
        orderFrom: order?.integrations?.orderSource || order.orderSource || "N/A",
        price: totalPrice,
        status: normalizedStatus,
        paymentStatus: normalizedPaymentStatus,
        createdAt: order.createdAt || order.created_at || new Date().toISOString(),
        deliveryInfo: order.fulfillment?.driver
            ? {
                  driverId: order.fulfillment.driver._id,
                  driverName: order.fulfillment.driver.name || order.fulfillment.driver.firstName || "N/A",
                  driverPhone: order.fulfillment.driver.phone || "N/A",
              }
            : null,
        preparation: order.preparation || null,
        delivery: order.delivery || null,
        driverCancellation: order.driverCancellation || null,
        updatedAt: order.updatedAt || order.updated_at || new Date().toISOString(),
    };
};

export {useCountdown, formatApiOrder};
